export default function Testimonials() {
  return (
    <section className="py-16 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-[60%_40%] gap-8 md:gap-0">
          <div className="md:pr-20 flex flex-col justify-center">
            <div className="mb-6 md:mb-8">
              <span className="text-gray-900 text-sm font-medium">• Depoimentos</span>
            </div>

            <div className="max-w-2xl">
              <div className="text-4xl md:text-6xl text-gray-300 mb-3 md:mb-4" style={{ fontFamily: 'Georgia, serif' }}>"</div>
              <blockquote className="text-2xl md:text-5xl font-medium text-gray-900 leading-tight mb-6 md:mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
                A experiência foi excepcional. Encontrei a armação perfeita e o atendimento superou todas as expectativas.
              </blockquote>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                <p className="text-base md:text-lg font-bold text-gray-900">Maria Silva</p>
                <div className="flex items-center gap-1 bg-teal-50 px-3 py-1 rounded-full w-fit">
                  <i className="ri-star-fill text-teal-500 text-sm"></i>
                  <span className="text-sm text-gray-700">Google Reviews</span>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" style={{ height: '400px' }}>
            <img 
              src="https://public.readdy.ai/ai/img_res/97a0527670611c2fa48090acfd352f65.jpg"
              alt="Cliente satisfeito"
              className="w-full h-full object-cover object-top grayscale rounded-2xl md:rounded-none"
            />
          </div>
        </div>
      </div>
    </section>
  );
}